export enum AiTypingStatus {
  UNKNOWN = 'UNKNOWN',
  THINKING = 'THINKING',
  PREPARING = 'PREPARING',
  RESPONDING = 'RESPONDING',
}
